import {Route} from '@angular/router';
import {confirmEmailResolver, getAnonymousGuard} from '@scalified-monorepo/ng-shared/auth';

export default [
  {
    path: 'login',
    pathMatch: 'full',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
    canActivate: [getAnonymousGuard()],
  },
  {
    path: 'signup',
    pathMatch: 'full',
    loadComponent: () => import('./signup/signup.component').then(m => m.SignupComponent),
    canActivate: [getAnonymousGuard()],
  },
  {
    path: 'confirm-email',
    pathMatch: 'full',
    loadComponent: () => import('./confirm-email/confirm-email.component').then(m => m.ConfirmEmailComponent),
    canActivate: [getAnonymousGuard()],
    resolve: {signupData: confirmEmailResolver},
  },
  {
    path: 'password-reset',
    pathMatch: 'full',
    loadComponent: () => import('./reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    canActivate: [getAnonymousGuard()],
  },
  {
    path: 'verify-email',
    pathMatch: 'full',
    loadComponent: () => import('./verify-email/verify-email.component').then(m => m.VerifyEmailComponent),
    canActivate: [getAnonymousGuard()],
  },
] satisfies Route[];
